import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { routeConstant } from "shared/routes/routeConstant";
import classNames from "classnames";
import styles from "../style.module.scss";

const NavItem = ({ title, Icon, IconActive, path }: SideBarItemPathType) => {
  const location = useLocation();
  const [active, setActive] = useState<boolean>(false);

  useEffect(() => {
    if (!path) {
      setActive(false);
      return;
    }

    if (path === location.pathname) {
      setActive(true);
      return;
    }

    if (path === routeConstant.designer.allProjects.path) {
      if (location.pathname.startsWith(`${path}/`)) {
        setActive(true);
        return;
      }
    }

    if (path === routeConstant.designer.home.path) {
      if (
        location.pathname === routeConstant.designer.home.uploadRevision.path
      ) {
        setActive(true);
        return;
      }
    }

    setActive(false);
  }, [location.pathname, path]);

  return (
    <Link
      className={classNames(
        active ? styles.activeNavItemContainer : styles.navItemContainer,
        "w-full flex items-center gap-3",
      )}
      to={path ? path : ""}
    >
      {Icon && active ? <IconActive /> : <Icon />}
      <label className={classNames(styles.heading)} role="button">
        {title}
      </label>
    </Link>
  );
};

export default NavItem;
